import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import axios from 'axios';

const API_URL = "https://www.moga-dev.com/api/search/products";

export const fetchSearchResults = createAsyncThunk(
  'search/fetchSearchResults',
  async (searchTerm, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}?search_term=${searchTerm}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Search failed');
    }
  }
);

const searchSlice = createSlice({
  name: 'search',
  initialState: {
    results: [],             // all search results (raw)
    loading: false,
    error: null,
    currentPage: 0,
    itemsPerPage: 12,
    showAll: false,
    sortType: 'low-to-high', // default
  },
  reducers: {
    nextPage: (state) => {
      if (state.showAll) return;
      const maxPage = Math.floor(state.results.length / state.itemsPerPage);
      if (state.currentPage < maxPage) {
        state.currentPage += 1;
      }
    },
    prevPage: (state) => {
      if (state.showAll) return;
      if (state.currentPage > 0) {
        state.currentPage -= 1;
      }
    },
    goToPage: (state, action) => {
      if (state.showAll) return;
      state.currentPage = action.payload;
    },
    setSortType: (state, action) => {
      state.sortType = action.payload;
      state.currentPage = 0;
    },
    increaseItemsPerPage: (state) => {
      state.itemsPerPage += 12;
    },
    decreaseItemsPerPage: (state) => {
      if (state.itemsPerPage > 12) {
        state.itemsPerPage -= 12;
      }
    },
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
    },
    setShowAll: (state, action) => {
      state.showAll = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSearchResults.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSearchResults.fulfilled, (state, action) => {
        state.loading = false;
        state.results = action.payload;
        state.currentPage = 0;
      })
      .addCase(fetchSearchResults.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Selector for sorted + paginated search results
export const selectPaginatedSearchResults = (state) => {
  const { results, currentPage, itemsPerPage, showAll, sortType } = state.search;

  let sorted = [...results];

  // ✅ Sort by price
  switch (sortType) {
    case "low-to-high":
      sorted.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
      break;
    case "high-to-low":
      sorted.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
      break;
    default:
      break;
  }

  if (showAll) return sorted;

  const start = currentPage * itemsPerPage;
  const end = start + itemsPerPage;
  return sorted.slice(start, end);
};

export const {
  nextPage,
  prevPage,
  goToPage,
  setSortType,
  increaseItemsPerPage,
  decreaseItemsPerPage,
  setItemsPerPage,
  setShowAll,
} = searchSlice.actions;

export default searchSlice.reducer;
